const skillTypes = [
  {
    value: null,
    text: 'Please Select a skill type',
    disabled: true,
  },
  {
    value: 'reading',
    text: 'Reading',
    short: 'RE',
    icon: 'BookOpenIcon',
  },
  {
    value: 'writing',
    text: 'Writing',
    short: 'WR',
    icon: 'Edit3Icon',
  },
  {
    value: 'listening',
    text: 'Listening',
    short: 'LI',
    icon: 'HeadphonesIcon',
  },
  {
    value: 'speaking',
    text: 'Speaking (open ended)',
    short: 'SP',
    icon: 'MicIcon',
  },
  {
    value: 'typing',
    text: 'Typing',
    short: 'TY',
    icon: 'TypeIcon',
  },
  {
    value: 'pronunciation',
    text: 'Pronunciation',
    short: 'PR',
    icon: 'Volume2Icon',
  },
]

export default skillTypes
